import { DatePipe } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { ISettings, SETTINGS } from '@lsq-frontend/angular-shared/settings';
import { DateFormat } from '../../../constants/date-format.constants';
import { SHA } from '../../../constants/injector.constants';
import { ISha } from '../../../models/common';
import { GenericHealthService } from '@lsq-frontend/angular-shared/features/generic-get-services';

@Component({
    selector: 'health',
    template: `
        <lsq-banner [titleText]="settings.applicationName + ' Health'"></lsq-banner>
        <div class="container-fluid page-container">
            <div class="row">
                <div class="col-12 line">
                    <strong>Client Health Status</strong>
                </div>
                <div class="col-2 line">
                    Version:
                </div>
                <div class="col-10 line">
                    {{ webSha.version }}
                </div>
                <div class="col-2 line">
                    SHA:
                </div>
                <div class="col-10 line">
                    {{ webSha.sha }}
                </div>
                <div class="col-2 line">
                    Updated:
                </div>
                <div class="col-10 line">
                    {{ webSha.date }}
                </div>
            </div>
            <div class="row mt-4">
                <div class="col-12 line">
                    <strong>Server Health Status</strong>
                </div>
                <div class="col-2 line">
                    Health:
                </div>
                <div class="col-10 line">
                    {{ serverSha.status }}
                </div>
                <div class="col-2 line">
                    Version:
                </div>
                <div class="col-10 line">
                    {{ serverSha.version }}
                </div>
                <div class="col-2 line">
                    SHA:
                </div>
                <div class="col-10 line">
                    {{ serverSha.sha }}
                </div>
                <div class="col-2 line">
                    Updated:
                </div>
                <div class="col-10 line">
                    {{ serverSha.date }}
                </div>
            </div>
        </div>
    `
})
export class LsqHealthComponent {
    public serverSha: ISha;
    public webSha: ISha;

    constructor(
        @Inject(SETTINGS) public settings: ISettings,
        @Inject(SHA) public sha: ISha,
        private datePipe: DatePipe,
        private genericHealthService: GenericHealthService
    ) {
        this.webSha = { ...sha };
        if (sha.date) {
            this.webSha.date = this.datePipe.transform(new Date(sha.date), DateFormat.DateTime);
        }

        this.serverSha = {
            status: 'Loading Status ...',
            version: '-',
            sha: '-',
            date: '-'
        };

        this.getHealthResponse(); // tslint:disable-line
    }

    public async getHealthResponse(): Promise<void> {
        let response: any;
        try {
            response = await this.genericHealthService.executeOnce();
        } catch {
            this.serverSha.status = 'Non-Responsive';
            return;
        }
        this.serverSha.status = response.ok ? 'Healthy' : 'Unhealthy';
        this.serverSha.version = response.versionNumber;
        this.serverSha.sha = response.sha;
        if (response.date) {
            this.serverSha.date = this.datePipe.transform(response.date, DateFormat.DateTime);
        }
    }
}
